module.exports = __webpack_public_path__ + "/bundle/asset/im-1-6d5971e789fa767e95851d0019c64a57.png";